import { render, staticRenderFns } from "./EventTypePage.vue?vue&type=template&id=2258b31b"
import script from "./EventTypePage.vue?vue&type=script&lang=js"
export * from "./EventTypePage.vue?vue&type=script&lang=js"
import style0 from "./EventTypePage.vue?vue&type=style&index=0&id=2258b31b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports